import SignUp from "components/pages/SignUp"
import { useRedirectLoggedInUsers } from "hooks/misc/useRedirectLoggedInUsers"

export default function SignUpPage() {
  useRedirectLoggedInUsers()
  return <SignUp />
}
